export default __webpack_public_path__ + "images/c72634e9c1170b85a0301d5134063f89.png";